import { IPrice, IStripeSchedule } from '../payments';
import { IStripeCustomerSubscriptionDataPlanWrapper } from '../wrapper';

export interface IPhaseActionInfo {
  enabled: boolean;
  message?: string;
  earliestStart?: Date; // now
  earliestEnd?: Date; // now
  latestStart?: Date; // contract end date - 1
  latestEnd?: Date; // contract end date
  freePauseDurationAllowed?: boolean;
  cancelEnabled?: boolean;
}

export interface IPauseSubscription extends IPhaseActionInfo {
    allowedPlanIds?: Array<{name: string | null, price: string, accountId: string}>;
}

export interface IFreeWeekSubscription extends IPhaseActionInfo {
    allowedPlanIds?: Array<{name: string | null, price: string, accountId: string}>;
}

export interface ICancelSubscription {
    enabled: boolean;
    message: string;
    date: Date; // readonly - user cannot choose. start of next billing cycle
    defaultPenaltyAmount: number;
    enabledCancellationFeeOverride: boolean;
}

export interface IStartSubscription {
  enabled: boolean;
  message: string;
  allowedPlans: IPrice[];
}

export interface ICancelSubscriptionResponse {
    penaltyAmount: number;
    cancelDate: Date;
}

export interface IStartSubscriptionResponse {
  id: string;
  plan: IStripeCustomerSubscriptionDataPlanWrapper | null;
  start_date: number;
  metaData: {[name: string]: string};
}

export class UserAccountScheduleActionInfo {
    public subscriptionSchedule: IStripeSchedule | undefined;
    public pauseSubscriptionInfo: IPauseSubscription | undefined;
    public cancelSubscriptionInfo: ICancelSubscription | undefined;
    public startSubscriptionInfo: IStartSubscription | undefined;
    public freeWeekSubscriptionInfo: IFreeWeekSubscription | undefined;
    public subscribeEnabled = false; // not implemented yet
    public upgradeEnabled = false; // not implemented yet
}

export interface IContractDurationDetails {
    contractStart?: number;
    contractEnd?: number;
    extendedContractInDays?: number;
    isContract: boolean;
    hasShedule: boolean;
}
